import React from 'react';
import { Tooltip } from '@mui/material';
import { CountryBadge } from 'framework/form';
import useFieldHelper from './fieldHelper';
import { FieldProps } from './types';

interface CountryFlagFieldProps extends FieldProps {
  hasTooltip?: boolean;
}

const CountryFlagField = ({ source, hasTooltip = false, ...props }: CountryFlagFieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const value = getValue();
  const flagComponent = <CountryBadge country={value} />;
  if (!flagComponent) {
    return null;
  }
  return hasTooltip ? (
    <Tooltip title={value}>
      <span>{flagComponent}</span>
    </Tooltip>
  ) : (
    flagComponent
  );
};

export default CountryFlagField;
